<template>
  <v-container fluid>
    <v-btn
      :to="{ name: 'admin.index' }"
      elevation="0"
      tile
      icon
    >
      <v-icon size="20">mdi-arrow-left</v-icon>
    </v-btn>

    <v-divider class="mb-3 mt-1"></v-divider>

    <v-row>
      <v-dialog v-model="modal" max-width="600">
        <v-card>
          <v-card-title>{{!toggle ? 'Create Button' : 'Create Permission'}}</v-card-title>

          <v-card-text>
            <v-form>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.titleEN"
                    :label="!toggle ? 'Title EN' : 'Nombre'"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="6" v-if="!toggle">
                  <v-text-field
                    v-model="form.subtitleEN"
                    label="Subtitle EN"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="6" v-if="!toggle">
                  <v-text-field
                    v-model="form.titleFR"
                    label="Title FR"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="6" v-if="!toggle">
                  <v-text-field
                    v-model="form.subtitleFR"
                    label="Subtitle FR"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="6" v-if="!toggle">
                  <v-text-field
                    v-model="form.url"
                    label="URL"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="6" v-if="!toggle">
                  <v-select
                    v-model="form.icon"
                    :items="icons.filter(transformIcon)"
                    label="Icon"
                    solo
                    dense
                  >
                    <template v-slot:item="{ item }">
                      <v-icon color="grey lighten-1" class="mr-4">
                        mdi-{{ transformIcon(item) }}
                      </v-icon>
                      {{ item }}
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="6" v-if="!toggle">
                  <v-text-field
                    v-model="form.image"
                    label="Image"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-select
                    v-model="form.parentId"
                    :items="idsNotCurrent"
                    label="Parent"
                    solo
                    dense
                  >
                    <template v-slot:item="{ item }">
                      <span :class="{
                        'font-weight-bold': !(item.text || '').startsWith('-'),
                      }">
                        {{ item.text }}
                      </span>
                    </template>
                </v-select>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn
                    @click="submit"
                    :disabled="disabled"
                    type="submit"
                    color="primary"
                    small
                  >Save</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>

        <template v-slot:activator="{ on }">
          <v-col cols="12" class="text-right d-flex align-center justify-end">
            <v-switch
              class="ml-2 mr-2"
              v-model="toggle"
              :label="!toggle ? 'Menu Button' : 'Feature Permission'"
            ></v-switch>
            <v-spacer></v-spacer>
            <v-btn
              v-if="updateEnabled"
              @click="updateOrder"
              :disabled="disabled"
              class="mr-4"
              color="primary"
              small
            >Update Order</v-btn>

            <v-select
              v-if="!toggle"
              class="mr-4 permissions__parent"
              label="Parent"
              v-model="parent"
              :items="defaultParents.concat(ids)"
              @change="parentChange"
              hide-details
              solo
              dense
            >
              <template v-slot:item="{ item }">
                <span :class="{
                  'font-weight-bold': !(item.text || '').startsWith('-'),
                }">
                  {{ item.text }}
                </span>
              </template>
            </v-select>

            <v-btn
              @click="open(on)"
              color="primary"
              fab
              x-small
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </template>
      </v-dialog>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-simple-table v-if="!toggle">
          <template>
            <thead>
              <tr>
                <th class="text-no-wrap" v-if="parent">Order</th>
                <th class="text-no-wrap">Title EN</th>
                <th class="text-no-wrap">Subtitle EN</th>
                <th class="text-no-wrap">Title FR</th>
                <th class="text-no-wrap">Subtitle FR</th>
                <th class="text-no-wrap">URL</th>
                <th class="text-no-wrap">Icon</th>
                <th class="text-no-wrap">Image</th>
                <th class="text-no-wrap">Parent</th>
                <th class="text-no-wrap text-right">Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(i, index) in itemsFiltered" :key="i.guid">
                <td class="text-no-wrap" v-if="parent !== ''">
                  <v-btn
                    @click="moveUp(index)"
                    :disabled="index === 0"
                    tile
                    icon
                  >
                    <v-icon>mdi-arrow-up</v-icon>
                  </v-btn>

                  <v-btn
                    @click="moveDown(index)"
                    :disabled="index === itemsFiltered.length - 1"
                    tile
                    icon
                  >
                    <v-icon>mdi-arrow-down</v-icon>
                  </v-btn>
                </td>
                <td class="text-no-wrap" :title="i.titleEN">{{ i.titleEN }}</td>
                <td class="text-no-wrap" :title="i.subtitleEN">{{ i.subtitleEN }}</td>
                <td class="text-no-wrap" :title="i.titleFR">{{ i.titleFR }}</td>
                <td class="text-no-wrap" :title="i.subtitleFR">{{ i.subtitleFR }}</td>
                <td class="text-no-wrap" :title="i.url">{{ i.url }}</td>
                <td class="text-no-wrap" :title="i.icon">{{ i.icon }}</td>
                <td class="text-no-wrap" :title="i.image">{{ i.image }}</td>
                <td class="text-no-wrap" :title="parentName(i)">{{ parentName(i) }}</td>
                <td class="text-no-wrap text-right">
                  <v-btn @click="open(i)" tile icon>
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>

                  <app-delete :item="i" :fields="['titleEN', 'titleFR']" @confirm="remove(i)">
                    <template v-slot="{ on }">
                      <v-btn tile icon v-on="on">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </app-delete>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <v-simple-table v-else>
          <template>
            <thead>
              <tr>
                <th class="text-no-wrap">Name</th>
                <th class="text-no-wrap">Parent</th>
                <th class="text-no-wrap text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="permission in itemsURLs" :key="permission.guid">
                <td class="text-no-wrap">{{ permission.titleEN }}</td>
                <td class="text-no-wrap">{{ parentName(permission) }}</td>
                <td class="text-no-wrap text-right">
                  <v-btn @click="open(permission)" tile icon>
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>

                  <app-delete
                    :item="permission"
                    :fields="['titleEN', 'titleFR']"
                    @confirm="remove(permission)"
                  >
                    <template v-slot="{ on }">
                      <v-btn tile icon v-on="on">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </app-delete>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Menu } from '@/api';

export default {
  name: 'app-menu-create',
  data() {
    return {
      toggle: false,
      modal: false,
      disabled: false,
      updateEnabled: false,
      parent: '',
      items: [],
      form: {
        titleEN: '',
        subtitleEN: '',
        titleFR: '',
        subtitleFR: '',
        url: '',
        icon: '',
        parentId: '',
      },
      icons: [
        'echo',
        'bpm',
        'tempo',
        'about',
        'kpi',
        'bi',
        'reports',
        'dashboards',
        'apps',
        'docs',
        'news',
        'contacts',
        'trackandtrace',
        'locations',
        'ordercreation',
        'rapports',
        'consolidation',
        'trackandtraceosol',
        'clientorder',
        'preparationorder',
        'shippingorder',
        'handlingunit',
        'product',
        'stockmanagement',
      ],
    };
  },
  computed: {
    defaultParents() {
      return [
        { text: 'Default', value: '' },
        { text: 'None', value: null },
      ];
    },
    ids() {
      const parents = this.items.filter(i => !i.parentId);
      const items = [];

      parents.map((p) => {
        items.push({
          text: p.titleEN || p.titleFR,
          value: p.guid,
        });

        this.items
          .filter(i => this.rootParentId(i, p.guid))
          .map((i) => {
            items.push({
              text: `- ${i.titleEN || i.titleFR}`,
              value: i.guid,
            });

            return true;
          });

        return true;
      });

      return items;
    },
    idsNotCurrent() {
      return this.ids.filter(i => i.value !== this.form.guid);
    },
    itemsFiltered() {
      return this.parent !== ''
        ? this.items
          .filter(i => i.parentId === this.parent)
          .filter(i => i.url !== ':permission')
          .sort((a, b) => (a.order > b.order ? 1 : -1))
        : this.items.filter(i => i.url !== ':permission');
    },
    itemsURLs() {
      return this.items.filter(i => i.url === ':permission');
    },
  },
  methods: {
    transformIcon(name) {
      return {
        kpi: 'chart-pie',
        tempo: 'axis-arrow',
        trackandtrace: 'target',
        docs: 'file-multiple',
        apps: 'console',
        shippingorder: 'map-marker-distance',
      }[name];
    },
    async updateOrder() {
      this.disabled = true;

      try {
        await Menu.order(this.itemsFiltered);
      } catch (e) {
        console.debug('ERROR', e);
      }

      this.disabled = false;
      this.updateEnabled = false;
    },
    setOrder(items) {
      return items.map((i, index) => {
        // eslint-disable-next-line
        i.order = index;
        return i;
      });
    },
    moveUp(index) {
      const items = this.setOrder(window._.cloneDeep(this.itemsFiltered));
      items[index].order = index - 1;
      items[index - 1].order = index;
      this.updateItems(items);
      this.updateEnabled = true;
    },
    moveDown(index) {
      const items = this.setOrder(window._.cloneDeep(this.itemsFiltered));
      items[index].order = index + 1;
      items[index + 1].order = index;
      this.updateItems(items);
      this.updateEnabled = true;
    },
    updateItems(items) {
      this.items.map((i, index) => {
        const j = items.findIndex(t => t.guid === i.guid);
        if (j !== -1) this.items.splice(index, 1, items[j]);
        return i;
      });
    },
    parentName(item) {
      return item.parent
        ? (item.parent.titleEN || item.parent.titleFR)
        : '';
    },
    reset() {
      this.form = {
        titleEN: '',
        subtitleEN: '',
        titleFR: '',
        subtitleFR: '',
        url: '',
        icon: '',
        parentId: '',
      };
    },
    async fetch() {
      this.$store.commit('START_LOADING');

      try {
        this.items = (await Menu.fetch()).data;
      } catch (e) {
        console.debug('ERROR', e);
      }

      this.$store.commit('END_LOADING');
    },
    async remove(item) {
      await Menu.delete(item.guid);
      await this.fetch();
    },
    open(item, on) {
      if (on) on.click();
      else this.modal = true;
      if (item) {
        this.form = window._
          .chain(item)
          .cloneDeep()
          .omit('parent')
          .value();
      } else this.reset();
    },
    close() {
      this.reset();
      this.modal = false;
      this.disabled = false;
    },
    async submit(e) {
      e.preventDefault();
      this.disabled = true;

      if (this.toggle) this.form.url = ':permission';

      try {
        if (this.form.guid) await Menu.update(this.form);
        else await Menu.create(this.form);
      } catch (err) {
        console.debug('ERROR', err);
      }

      await this.fetch();
      this.close();
    },
    parentChange() {
      this.updateEnabled = false;
    },
    rootParentId(item, id) {
      if (item.parentId && item.parentId !== id) {
        return this.rootParentId(item.parent, id);
      }

      return item.parentId === id;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
